module.exports = __webpack_public_path__ + "static/media/tachometer-alt-fastest.284349e8.svg";